export default class Doctors {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    // Initialize doctors filter functionality when page loads
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    // Only initialize if doctors list banner exists on current page
    if ($("#section-doctors-list-banner").length > 0) {
      this.doctorsFilterSetup();
    }
  }

  doctorsFilterSetup() {
    // Initialize currentHospital from active option
    this.currentHospital = this.getCurrentHospitalFromActive();

    // Bind hospital input change event
    this.bindHospitalInputChange();

    // Bind hospital option clicks
    this.bindHospitalOptionClicks();

    // Initial filter of specialties
    this.filterSpecialtiesByHospital(this.currentHospital);
  }

  /**
   * Get current hospital ID from active option in hospital select
   * Returns "all" if no active option found
   */
  getCurrentHospitalFromActive() {
    const $activeOption = $(
      "#hospital-select .select-options-list .option.active"
    ).first();

    if (!$activeOption.length) {
      return "all";
    }

    const hospitalId = $activeOption.data("hospital-id");
    return hospitalId || "all";
  }

  /**
   * Bind change event to hospital input
   * Updates currentHospital when input changes
   * Gets hospital ID from active option, not from input
   */
  bindHospitalInputChange() {
    const $hospitalInput = $("#hospital-input");

    $hospitalInput.on("change", () => {
      // Get hospital ID from active option, not from input
      const hospitalId = this.getCurrentHospitalFromActive();
      // console.log(hospitalId);
      this.currentHospital = hospitalId;

      // Reset specialty selection to default
      this.resetSpecialtySelection();

      // Filter specialties based on new hospital
      this.filterSpecialtiesByHospital(this.currentHospital);
    });
  }

  /**
   * Bind click events on hospital options
   * Updates hidden input when user clicks an option
   */
  bindHospitalOptionClicks() {
    const self = this;

    $(document).on("click", "#hospital-select .option", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $option = $(this);
      const $select = $option.closest(".custom-select");
      const $currentValue = $select.find(".current-value");
      const $hiddenInput = $("#hospital-input");

      const value = $option.data("value");
      const text = $option.text().trim();
      const hospitalId = $option.data("hospital-id") || "all";

      // Update UI - mark selected option as active
      $select.find(".option").removeClass("active");
      $option.addClass("active");
      $currentValue.html(text).removeClass("default-value");

      // Update hidden input
      $hiddenInput.val(value).attr("data-hospital-id", hospitalId);

      // Update currentHospital and filter specialties
      self.currentHospital = hospitalId;

      // Reset specialty selection to default
      self.resetSpecialtySelection();

      // Filter specialties based on new hospital
      self.filterSpecialtiesByHospital(self.currentHospital);

      // Close the dropdown
      $select.removeClass("active");
    });
  }

  /**
   * Filter specialty options based on currentHospital
   * @param {string} hospitalId - The ID of the selected hospital ("all" or numeric ID)
   */
  filterSpecialtiesByHospital(hospitalId) {
    const $specialtyOptions = $(
      "#specialty-select .select-options-list .option"
    );

    // If "all", show all specialties
    if (hospitalId === "all" || !hospitalId) {
      $specialtyOptions.each(function () {
        $(this).show().css("display", "");
      });
      return;
    }

    // Convert hospitalId to number for comparison
    const hospitalIdNum = parseInt(hospitalId, 10);

    // Filter specialties based on data-hospitals
    $specialtyOptions.each(function () {
      const $option = $(this);
      const optionValue = $option.data("value");

      // Always show "All" option
      if (optionValue === "all") {
        $option.show();
        return;
      }

      // Get hospitals data
      let hospitalsData = $option.data("hospitals");

      // If not already an array, try to parse from attribute
      if (!Array.isArray(hospitalsData)) {
        const rawAttr = $option.attr("data-hospitals");
        if (rawAttr) {
          try {
            hospitalsData = JSON.parse(rawAttr);
          } catch (err) {
            hospitalsData = [];
          }
        } else {
          hospitalsData = [];
        }
      }

      // Check if current hospital is in the list
      if (
        Array.isArray(hospitalsData) &&
        hospitalsData.includes(hospitalIdNum)
      ) {
        $option.show();
      } else {
        $option.hide();
      }
    });
  }

  /**
   * Reset specialty selection to default state
   * Removes active class from all options and resets UI to "Choose specialty"
   */
  resetSpecialtySelection() {
    const $specialtySelect = $("#specialty-select");
    const $specialtyCurrentValue = $specialtySelect.find(".current-value");
    const $specialtyHiddenInput = $("#specialty-filter-input");
    const lang = HM_Variables.language;

    // Remove active state from all specialty options
    $specialtySelect.find(".option").removeClass("active");

    // Set "All" option as active
    $specialtySelect.find(".option[data-value='all']").addClass("active");

    // Reset display text to default placeholder
    $specialtyCurrentValue
      .html(lang === "vi" ? "Chọn chuyên khoa" : "Choose specialty")
      .addClass("default-value");

    // Reset hidden input to "all"
    $specialtyHiddenInput.val("all").attr("data-raw-id", "all");
  }
}
